import {
    REGISTER_DATA_UPDATE,
    REGISTER_USER,
    REGISTER_USER_FAIL,
    REGISTER_USER_SUCCESS,
    REGISTER_UPDATE_USER_DATA
} from './types';

import { REGISTER_POST } from '../../api/authEndpoints';
import post from "../../api/methods/post";

const registerUserFail = (dispatch, message) => {
    dispatch({
        type: REGISTER_USER_FAIL,
        payload: message
    });
};

const registerUserSuccess = (dispatch) => {
    dispatch({ type: REGISTER_USER_SUCCESS });
};

export const registerUserAsync = (user) => {
    return async (dispatch) => {
        dispatch({ type: REGISTER_USER });

        const registerBody = {
            email: user.email,
            password: user.userPassword,
            userName: user.userName,
            userNickname: user.userNickname,
            estabelecimento: user.estabelecimento,
            telefone: user.telefone,
            estado: user.estado,
            cidade: user.cidade,
            cnpj: user.cnpj,
            nomeFantasia: user.nomeFantasia,
        };

        try {

            let registerResponse = await post(REGISTER_POST, registerBody);
            let registerResponseJson = await registerResponse.json();

            registerUserSuccess(dispatch);
            return registerResponseJson;
        } catch (e) {
            registerUserFail(dispatch);
            throw (e);
        }
    }
};
